@if (accountsDatasource) {
    <app-server-side-grid
        [colDefs]="gridColumns"
        [datasource]="accountsDatasource"
        [appliedSort]="appliedSort"
        [noRows]="noResults()"
        [titleNoData]="'No Accounts available.'"
        (cellSorting)="onSortChanged($event)"
    >
    </app-server-side-grid>
}
